import { useGetFilters } from '@components/TableV2/hooks/useGetFilters';
import { IFilterSettings } from '@components/TableV2/types';
import { Translate } from '@hooks/useI18n/types';
import {
  FilterTypes,
  TableNames,
  missingValuePlaceholder,
} from '@utils/constants';
import { PaidType } from '@utils/enums';
import { IMerchantReceivablesFilterValues } from './types';

interface IUseGetMerchantReceivablesFilters {
  initialDefaultValues: IMerchantReceivablesFilterValues;
  translate: Translate;
}

export const useGetMerchantReceivablesFilters = ({
  initialDefaultValues,
  translate,
}: IUseGetMerchantReceivablesFilters): IFilterSettings<IMerchantReceivablesFilterValues> => {
  const { filterHandler, filterValues, resetFiltersHandler } = useGetFilters(
    TableNames.MERCHANT_RECEIVABLES,
    initialDefaultValues,
  );

  const paidStatusDropdownOptions = [
    { id: '', name: missingValuePlaceholder },
    { id: PaidType.Paid, name: translate('OPS_PORTAL.LABEL.PAID') },
    {
      id: PaidType.Unpaid,
      name: translate('OPS_PORTAL.LABEL.UNPAID'),
    },
  ];

  const paidStatusDropdown = {
    accessorKey: 'paid',
    id: 'paid',
    label: translate('TITLE.STATUS'),
    options: paidStatusDropdownOptions,
    type: FilterTypes.DROPDOWN,
    value: filterValues.paid ?? '',
  };

  return {
    filters: [
      paidStatusDropdown,
      {
        accessorKey: 'createdDateFrom',
        from: {
          id: 'createdDateFrom',
          label: translate('LABEL.START_DATE'),
          value: filterValues.createdDateFrom ?? '',
        },
        id: 'createdDateRange',
        to: {
          id: 'createdDateTo',
          label: translate('LABEL.END_DATE'),
          value: filterValues.createdDateTo ?? '',
        },
        type: FilterTypes.DATE_RANGE,
      },
    ],
    filterHandler,
    initialDefaultValues,
    resetFiltersHandler,
    filterValues,
  };
};
